import React from 'react';
import '../template-file-css/document-file-template.css';


export const GFIT_AdultServiceOrder = ({ itemsRef, howErrorFor, }) => {

    return (
        <form id='GFIT_AdultServiceOrder' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'>
                    <h1> <center> Georgia Families in Transition Service Order </center> </h1>
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> 1. First Name: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Last Name: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Date of Birth: </span> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <input type='text' id='txtFirstName' name='txtFirstName' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLastName' name='txtLastName' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDateOfBirth' name='txtDateOfBirth' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Start date: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> End date:  </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Medicaid #: </span> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <input type='date' id='txtStartDate' name='txtStartDate' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtEndDate' name='txtEndDate' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtMedicaid' name='txtMedicaid' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> 2. THE ASSESSMENT HAS BEEN REVIEWED AND THE FOLLOWING SERVICES HAVE BEEN ORDERED AND APPROVIED FOR THE CLIENT BASED ON THE GA DBHDD CRITERIA: </span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-30'>
                        </td>
                        <td className='w-170'>
                            <span className='eleHeader'> Diagnosis Code </span> </td>

                        <td className='w-550'>
                            <span className='eleHeader'> Diagnosis Title </span> </td>
                    </tr>

                    <tr>
                        <td className='w-30'> A. </td>
                        <td className='w-170'>
                            <input type='text' id='txtDiagnosisCode_1' name='txtDiagnosisCode_1' className='add-only' /> </td>

                        <td className='w-550'>
                            <input type='text' id='txtDiagnosisTitle_1' name='txtDiagnosisTitle_1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-30'> B. </td>
                        <td className='w-170'>
                            <input type='text' id='txtDiagnosisCode_2' name='txtDiagnosisCode_2' className='add-only' /> </td>

                        <td className='w-550'>
                            <input type='text' id='txtDiagnosisTitle_2' name='txtDiagnosisTitle_2' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-30'> C. </td>
                        <td className='w-170'>
                            <input type='text' id='txtDiagnosisCode_3' name='txtDiagnosisCode_3' className='add-only' /> </td>

                        <td className='w-550'>
                            <input type='text' id='txtDiagnosisTitle_3' name='txtDiagnosisTitle_3' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-30'> D. </td>
                        <td className='w-170'>
                            <input type='text' id='txtDiagnosisCode_4' name='txtDiagnosisCode_4' className='add-only' /> </td>

                        <td className='w-550'>
                            <input type='text' id='txtDiagnosisTitle_4' name='txtDiagnosisTitle_4' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> 3. SERVICE BEING PROVIDED TO CONSUMER (Please check all that apply) </span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbBehavioralHealthAssessment' name='cbBehavioralHealthAssessment' className='add-only' value='Behavioral Health Assessment & Service Plan' /> Behavioral Health Assessment & Service Plan
                        </td>

                        <td className='w-375'>
                            <input type='checkbox' id='cbGroupOutpatientServices' name='cbGroupOutpatientServices' className='add-only' value='Group Outpatient Services' /> Group Outpatient Services
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAddictiveDisease' name='cbAddictiveDisease' className='add-only' value='Addictive Disease Support Services' /> Addictive Disease Support Services
                        </td>

                        <td className='w-375'>
                            <input type='checkbox' id='cbCrisisIntervention' name='cbCrisisIntervention' className='add-only' value='Crisis Intervention' /> Crisis Intervention
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCommunitySupportIndividual ' name='cbCommunitySupportIndividual' className='add-only' value='Community Support Individual' /> Community Support Individual
                        </td>

                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychosocialRehabilitation' name='cbPsychosocialRehabilitation' className='add-only' value='Psychosocial Rehabilitation Individual' /> Psychosocial Rehabilitation Individual
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbIndividualOutpatient' name='cbIndividualOutpatient' className='add-only' value='Individual Outpatient Services' /> Individual Outpatient Services
                        </td>

                        <td className='w-375'>
                            <input type='checkbox' id='cbCaseManagement' name='cbCaseManagement' className='add-only' value='Case Management' /> Case Management
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCommunityTransitionPlanning' name='cbCommunityTransitionPlanning' className='add-only' value='Community Transition Planning' /> Community Transition Planning
                        </td>

                        <td className='w-375'>
                            <input type='checkbox' id='cbIntensiveFamilyIntervention' name='cbIntensiveFamilyIntervention' className='add-only' value='Intensive Family Intervention' /> Intensive Family Intervention
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFamilyOutpatientServices' name='cbFamilyOutpatientServices' className='add-only' value='Family Outpatient Services' /> Family Outpatient Services
                        </td>

                        <td className='w-375'>
                            <input type='checkbox' id='cbFamilySkillsTraining' name='cbFamilySkillsTraining' className='add-only' value='Family Skills Training' /> Family Skills Training
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> 4. The above services have been ordered by the following licensed professional, please include credentials:
                            </span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <textarea id='PleaseIncludeCredentials' name='PleaseIncludeCredentials'> </textarea>
                        </td>
                    </tr>

                    <tr>
                        <td className='signature w-500'> &nbsp; </td>
                        <td className='signature w-250'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Licensed Clinician Signature, including credentials </td>
                        <td className='small w-250'> Date </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Printed Licensed Clinician Name, including credentials </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='PrintedLicensedClinicianName' name='PrintedLicensedClinicianName'> </textarea>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> 5. SERVICE BEING PROVIDED TO CONSUMER (Please check all that apply </span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNursing' name='cbNursing' className='add-only' value='Nursing' /> Nursing
                        </td>

                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychologicalTesting' name='cbPsychologicalTesting' className='add-only' value='Psychological Testing' /> Psychological Testing
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMedicationManagement' name='cbMedicationManagement' className='add-only' value='Medication Management' /> Medication Management
                        </td>

                        <td className='w-375'>
                            <input type='checkbox' id='cbDiagnosticAssessment' name='cbDiagnosticAssessment' className='add-only' value='Diagnostic Assessment' /> Diagnostic Assessment
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatricServices' name='cbPsychiatricServices' className='add-only' value='Psychiatric Services' /> Psychiatric Services
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> 6. The above services have been ordered by the following Licensed Doctor, Nurse Practitioner, or Psychiatrist, please include credentials
                            </span>
                        </td>
                    </tr>

                    <tr>
                        <td className='signature w-500'> &nbsp; </td>
                        <td className='signature w-250'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Doctor/NP/Psychiatrist Signature, including credentials </td>
                        <td className='small w-250'> Date </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Printed Doctor/NP/Psychiatrist Name, including credentials </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='PsychiatristName' name='PsychiatristName'> </textarea>
                        </td>
                    </tr>
                </table>





            </div>
        </form>

    )
}